const formFields = [
    { field: 'serialNumber', selector: 'input[name="serialNumber"]' },
    { field: 'verificationCode', selector: 'input[name="verificationCode"]' },
    { field: 'serialNumber_confirmation', selector: 'input[name="serialNumber_confirmation"]' },
    { field: 'subscriptions', selector: 'input[name="subscriptions"]' },
];

const sentFormFields=[
    { field: 'serialNumber', selector: 'input[name="serialNumber"]' },
    { field: 'serialNumber_confirmation', selector: 'input[name="serialNumber_confirmation"]' },
    { field: 'verificationCode', selector: 'input[name="verificationCode"]' },
]

const lostTagFormFields = [
    { field: 'lost_tag_reason', selector: 'textarea[name="lost_tag_reason"]' },
];

export { formFields, sentFormFields, lostTagFormFields };
